<template>
  <div class="c-quiz">
    <div class="container">
      <GreetingMission
        :title="$t('Completa il quiz!')"
        :description="
          $t('Rispondi correttamente alle domande nel minor tempo possibile')
        "
        @action="moveToNextStep"
        v-if="currentStep === 0"
      >
        <GreetingQuizSlot
          :time="totalTime"
          :questions="questionDetails.total_questions"
        />
      </GreetingMission>
      <QuizQuestion
        v-if="currentStep === 1"
        @moveToNextStep="moveToNextStep"
        @allQuestions="allQuestions"
        :questionDetails="questionDetails"
      />
      <RecapMission v-if="currentStep === 2" :data="questionRecap" />
    </div>
  </div>
</template>

<script>
import GreetingMission from "@/components/rebuild/common/GreetingMission";
import QuizQuestion from "@/components/rebuild/Quiz/QuizQuestion";
import RecapMission from "@/components/rebuild/Quiz/RecapMission";
import GreetingQuizSlot from "@/components/rebuild/Quiz/GreetingQuizSlot";

import { Actions } from "@/store/global/global.types";

import { mapGetters } from "vuex";

export default {
  name: "Quiz",
  components: {
    GreetingMission,
    QuizQuestion,
    RecapMission,
    GreetingQuizSlot
  },
  data() {
    return {
      currentStep: 0,
      questionDetails: {},
      questionRecap: {}
    };
  },
  computed: {
    ...mapGetters(["getUserTasks"]),
    totalTime() {
      return (
        this.questionDetails.seconds * this.questionDetails.total_questions
      );
    }
  },
  async mounted() {
    if (!this.getUserTasks.length) {
      await this.$store.dispatch(Actions.GET_USER_TASKS);
    }
    const task = this.getUserTasks.find(
      ({ data = {} }) => data.id === this.$route.params.instantwinId
    );
    if (!task) {
      this.$router.push("/dashboard");
      return;
    }
    this.questionDetails = task.data;
  },
  methods: {
    moveToNextStep() {
      this.currentStep = this.currentStep + 1;
    },
    allQuestions(data) {
      this.questionRecap = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-quiz {
  background-color: #fafafa;
  min-height: 100vh;
  @media (min-width: 767px) {
    min-height: unset;
    padding: 40px 0;
  }
}
</style>
